export const ActionTypes = {
  FROM_HISTORY: 'FROM_HISTORY',
  SET_VENDX_SESSION_ID: 'SET_VENDX_SESSION_ID',
  SET_LOADER: 'SET_LOADER',
  SET_TRANSCRIPT_SESSION: 'SET_TRANSCRIPT_SESSION',
  SET_USER_DETAILS: 'SET_USER_DETAILS',
  SET_CURRENT_RECORDING: 'SET_CURRENT_RECORDING',
  RESET_RECORDING: 'RESET_RECORDING',
  OPEN_SNACKBAR: 'OPEN_SNACKBAR',
  CLOSE_SNACKBAR: 'CLOSE_SNACKBAR',
};
